import {
  PAUSE_INTEGRATION_ACCOUNTS_REQ,
  PAUSE_INTEGRATION_ACCOUNTS_REQ_SUCCESS,
  PAUSE_INTEGRATION_ACCOUNTS_REQ_ERROR,
  ALERT_INTEGRATION_VIEW_PREFERENCES_REQ,
  SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES
} from './integration-accounts.type'

import ApiRest from '@/api/api-rest'

const state = {
  pauseIntegrationAccountsReqStatus: '',
  alertIntegrationPreferences: []
}

const getters = {
  pauseIntegrationAccountsReqStatus: state => state.pauseIntegrationAccountsReqStatus,
  alertIntegrationPreferences: state => state.alertIntegrationPreferences
}

// Best Practice - updates state
const mutations = {
  [PAUSE_INTEGRATION_ACCOUNTS_REQ]: state => (state.pauseIntegrationAccountsReqStatus = 'loading'),
  [PAUSE_INTEGRATION_ACCOUNTS_REQ_SUCCESS]: state => (state.pauseIntegrationAccountsReqStatus = 'saved'),
  [PAUSE_INTEGRATION_ACCOUNTS_REQ_ERROR]: state => (state.pauseIntegrationAccountsReqStatus = 'error'),
  [ALERT_INTEGRATION_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.alertIntegrationPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ALERT_INTEGRATION_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserAlertIntegrationPrefs = data.find(pref => {
            return pref.tbl_id === 17 && pref.user_id === uid
          })
          context.commit(ALERT_INTEGRATION_VIEW_PREFERENCES_REQ, currUserAlertIntegrationPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [PAUSE_INTEGRATION_ACCOUNTS_REQ] (context, { integrationId, action }) {
    context.commit(PAUSE_INTEGRATION_ACCOUNTS_REQ)
    return new Promise((resolve, reject) => {
      ApiRest()
        .put(`/integrations/accounts/toggleenable/${integrationId}`, {
          enabled: action === 'enable'
        })
        .then(({ data }) => {
          context.commit(PAUSE_INTEGRATION_ACCOUNTS_REQ_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PAUSE_INTEGRATION_ACCOUNTS_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/integration_accounts/integration-accounts.module.js